import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPoll = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 12,
		cy: 12,
		r: 9,
		stroke: "#8895A7",
		strokeWidth: 2
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8 11.3964L10.7593 14.9583C11.1647 15.4816 11.9575 15.4737 12.3524 14.9425L19 6",
		stroke: "#8895A7",
		strokeWidth: 2
	})]
});
export default SvgPoll;
